// WebSocket server-to-client command/message type IDs (duplicate for client-side type safety)
export const WS_SERVER_ERROR = 1;
export const WS_SERVER_DISCORD_REQUIRED = 2;
export const WS_SERVER_USER_DATA = 3;
export const IN_RANGE_PLAYERS_UPDATE = 4;
// Add more as needed
